import { HardcodedToDoCard } from '../types';

export type HardcodedToDo = 'intake' | 'profileImage' | 'uploadInsurance' | 'uploadID';
export type HardcodedToDoRecord = Record<HardcodedToDo, HardcodedToDoCard>;

export const HARDCODED_TODO_MAP: HardcodedToDoRecord = {
  intake: {
    title: 'Complete intake form',
    type: 'intake',
    explainer: {
      title: 'Complete your intake form',
      body: 'Please take 5 minutes to complete this before your first appointment.'
    }
  },
  profileImage: {
    title: 'Upload profile photo',
    type: 'profileImage',
    explainer: {
      title: 'Add a photo of yourself',
      body:
        "This not only will make your portal feel more like home, it's also important for identity verification in your first visit. Don't forget to bring in a photo ID!"
    }
  },
  uploadInsurance: {
    title: 'Upload insurance card',
    type: 'uploadInsurance',
    explainer: {
      title: 'Take photos of both sides of your insurance card',
      body:
        'Please upload photos of both sides of your insurance card so we can start checking your coverage!'
    }
  },
  uploadID: {
    title: 'Upload ID',
    type: 'uploadID',
    explainer: {
      title: 'Upload ID or driver’s license',
      body:
        'Please upload a photo of your ID or driver’s license so we can verify your identity. This will also save you waiting time when you check in at our clinic!'
    }
  }
};
